var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4418",
    "data-name": "Ellipse 4418",
    cx: 56,
    cy: 56,
    r: 56,
    transform: "translate(7994 21391)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_10675",
    "data-name": "Groupe 10675",
    transform: "translate(-7994 -21391)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4417",
    "data-name": "Ellipse 4417",
    cx: 56,
    cy: 56,
    r: 56,
    transform: "translate(7994 21391)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_de_masques_35",
    "data-name": "Groupe de masques 35",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_371",
    "data-name": "Trac\\xE9 371",
    d: "M8079.5,21417.834l26.667,42.666-21.042,53.5-16.375-7-17.5-12.25Z",
    fill: "#b9d0e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_372",
    "data-name": "Trac\\xE9 372",
    d: "M8045.083,21465.918l13.833,41.916-13.833.666-7.583-35.5Z",
    fill: "#b9d0e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_373",
    "data-name": "Trac\\xE9 373",
    d: "M8025,21472.334l8.167,39.082,26-3.582-19.5-51Z",
    fill: "#b9d0e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_374",
    "data-name": "Trac\\xE9 374",
    d: "M8021,21462.5l.641,11.516,13.193,35.65,24.583-2L8073.5,21490l-14.083-13.5-12.917-21.25,3.75-10.25-7.75,5.25-8.75-3.75Z",
    fill: "#b9d0e5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_10674",
    "data-name": "Groupe 10674",
    transform: "translate(-5.577 145.119)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_375",
    "data-name": "Trac\\xE9 375",
    d: "M8025,21292.428l59.571-19.713-19.714,59.428L8051.571,21309l14.286-18-19.143,14.715Z",
    fill: "none",
    stroke: "#176fbd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_376",
    "data-name": "Trac\\xE9 376",
    d: "M8035.875,21307.125l-7.5,7.625",
    transform: "translate(-1 1)",
    fill: "none",
    stroke: "#176fbd",
    strokeLinecap: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_377",
    "data-name": "Trac\\xE9 377",
    d: "M8045.5,21312l-15.375,15.375",
    transform: "translate(-1 1)",
    fill: "none",
    stroke: "#176fbd",
    strokeLinecap: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_378",
    "data-name": "Trac\\xE9 378",
    d: "M8049.75,21320.75l-7.625,7.75",
    transform: "translate(-1 1)",
    fill: "none",
    stroke: "#176fbd",
    strokeLinecap: "round",
    strokeWidth: 4
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSend);
export default __webpack_public_path__ + "static/media/icon-send.5aeaf5fdb697471c43e2ecc73f7bfd08.svg";
export { ForwardRef as ReactComponent };